"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  enter: 13,
  cancel: 27
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/key-codes.js
// module id = 870
// module chunks = 1